import { REGIONS, ERROR_STATE } from "./regionTypes";
import { apiHelper } from "../apiHelper"

export const Regions = () => async (dispatch) => {
  try {
    let res = await apiHelper("get", `fetch-regions`, '')
    
    if (res?.data) {
      if (res?.data) {
        let { data } = res
        dispatch({
          type: REGIONS,
          payload: data
        })

      }
      else {
        dispatch({
          type: ERROR_STATE
        })
      }
    };


  } catch (error) {
    console.log(error);
  }
}


